import {
  Box,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  calendarOptions,
  detailsTickets,
  setDetailsOptionValue,
  tripData,
} from 'src/redux/Calendar/sliceCalendar';
import ForwardIcon from '@material-ui/icons/Forward';
import { customFormat } from 'src/helpers/DateFormat';
import {
  IOptionDetails,
  IOptionsDetailsData,
} from 'src/redux/Calendar/interfaces';
import { getPlaceholderFromDefaultValues } from 'src/helpers/calendar/getNormalisedValueFromInput';
import { useStyles } from './styles';

export const OptionsUpdateForm = ({
  state,
  date,
}: {
  state: IOptionDetails;
  date: string;
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { option_type } = useSelector(calendarOptions);
  const data = useSelector(tripData);
  const detailedData: IOptionsDetailsData | undefined =
    useSelector(detailsTickets);
  const defaultOption = data?.additional_options.find(
    (i) => i.id === option_type
  );

  if (!defaultOption || !state.values?.length) return null;

  const changeState = (name: string, value: any, idx?: number) => {
    if (!detailedData) return;

    dispatch(
      setDetailsOptionValue({
        date,
        name,
        value,
        idx,
      })
    );
  };

  return (
    <Box borderBottom="0.8px solid rgba(0, 0, 0, 0.12)">
      <Box
        py={0.5}
        px={3}
        display="flex"
        alignItems="center"
        bgcolor={'#f5f5f5'}>
        <Typography variant="button" style={{ fontWeight: 500 }}>
          {customFormat(date, 'MMMM DD YYYY')}
        </Typography>
      </Box>
      <Box
        display="flex"
        width={1}
        justifyContent="center"
        alignItems="center"
        px={3}
        flexWrap="wrap"
        gridGap="10px">
        <Box mb={2} pr={4}>
          <Typography
            variant="h6"
            style={{
              padding: '8px 0',
            }}>
            {defaultOption.name}
          </Typography>
          <Box display="flex" alignItems="center" py={1}>
            <FormControlLabel
              control={<Switch className={classes.customSwitch} />}
              label="Disable Option"
              checked={Boolean(state.is_disabled && +state.is_disabled)}
              onChange={(_, checked) =>
                changeState('is_disabled', checked ? '1' : '0')
              }
            />
            <Box style={{ opacity: 0 }} display="flex">
              <ForwardIcon style={{ rotate: '90deg' }} />
            </Box>
          </Box>
        </Box>
        <Box py={2}>
          {state.values.map((i, idx) => (
            <Box
              key={`${date}_${i.id}`}
              display="flex"
              flexWrap="wrap"
              gridGap="10px"
              justifyContent="space-between"
              py={1.5}
              borderTop={idx ? '0.8px solid rgba(0, 0, 0, 0.12)' : undefined}>
              <Box
                mx={4}
                display="flex"
                alignItems="center"
                fontWeight={500}
                minWidth={'100px'}>
                {defaultOption.values.find((o) => o.id === +i.id)?.name || '-'}
              </Box>
              <Box mr={2} display="flex" alignItems="center">
                <TextField
                  type="number"
                  placeholder={getPlaceholderFromDefaultValues(
                    defaultOption.values.find((o) => o.id === +i.id)?.price ||
                      0,
                    2
                  )}
                  value={i.price || ''}
                  onChange={(e) => changeState('price', e.target.value, idx)}
                  variant="outlined"
                  className={classes.inputWrapper}
                  InputProps={{
                    style: {
                      width: '120px',
                      height: '40px',
                      background: '#fff',
                    },
                  }}
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      letterSpacing: '0.04em',
                    },
                  }}
                  label="Price"
                />
                <Box style={{ opacity: 0 }} display="flex" ml={0.5}>
                  <ForwardIcon style={{ rotate: '90deg' }} />
                </Box>
              </Box>
              <Box display="flex">
                <Box display="flex" alignItems="center" mr={4}>
                  <FormControlLabel
                    control={<Switch className={classes.customSwitch} />}
                    label="Disable"
                    checked={Boolean(i.is_disabled && +i.is_disabled)}
                    onChange={(_, checked) =>
                      changeState('is_disabled', checked ? '1' : '0', idx)
                    }
                  />
                  <Box style={{ opacity: 0 }} display="flex">
                    <ForwardIcon style={{ rotate: '90deg' }} />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center">
                  <FormControlLabel
                    control={<Switch className={classes.customSwitch} />}
                    label="Apply Tax"
                    checked={Boolean(i.apply_tax && +i.apply_tax)}
                    onChange={(_, checked) =>
                      changeState('apply_tax', checked ? '1' : '0', idx)
                    }
                    disabled
                  />
                  <Box style={{ opacity: 0 }} display="flex">
                    <ForwardIcon style={{ rotate: '90deg' }} />
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
